import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import {
  IEpDevPHealthValidationApiClient,
  IEpDevPValidateConfigResponse,
  IEpDevPValidateHealthResponse,
} from '../types';
import { 
  EpDevPHealthValidationApiPathsFactory 
} from './EpDevPHealthValidationApiFactories';



export class EpDevPHealthValidationApiClient extends EpDevPApiClient implements IEpDevPHealthValidationApiClient {

  public async validateHealth(): Promise<IEpDevPValidateHealthResponse> {
    const epDevPValidateHealthResponse: IEpDevPValidateHealthResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPHealthValidationApiPathsFactory.createValidateHealthPath())
    });    
    return epDevPValidateHealthResponse;
  }

  public async validateConfig(): Promise<IEpDevPValidateConfigResponse> {
    const epDevPValidateConfigResponse: IEpDevPValidateConfigResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPHealthValidationApiPathsFactory.createValidateConfigPath())
    });    
    return epDevPValidateConfigResponse;
  }

}
